import { Box } from '@mui/material';

import { PageHeaderTag, PageHeaderTitle } from './components';
import { useTreatmentPlanV3PageHeader } from './hooks';
import {
  PAGE_HEADER_ACTIONS_SX,
  PAGE_HEADER_ROOT_SX,
  PAGE_HEADER_TAGS_SX,
} from './styles';

import type { TreatmentPlanV3PageHeaderProps } from './components';

export default function TreatmentPlanV3PageHeader({ children }: TreatmentPlanV3PageHeaderProps) {
  const { planLabel, authorName, status, activation, bayLabel, paExpiry } =
    useTreatmentPlanV3PageHeader();

  return (
    <Box data-testid="appHeader" sx={PAGE_HEADER_ROOT_SX}>
      <PageHeaderTitle authorName={authorName} />
      <Box sx={PAGE_HEADER_TAGS_SX}>
        <PageHeaderTag testId="tpHeaderIdTag" label="TP ID" value={planLabel} />
        {status ? (
          <PageHeaderTag
            testId="tpHeaderStatusTag"
            label="TP status"
            value={status.label}
            dotColor={status.dotColor}
          />
        ) : null}
        <PageHeaderTag
          testId="tpHeaderActivationTag"
          label="Active/inactive"
          value={activation.label}
          dotColor={activation.dotColor}
        />
        {bayLabel ? (
          <PageHeaderTag testId="tpHeaderBayTag" label="Client bay" value={bayLabel} />
        ) : null}
        {paExpiry ? (
          <PageHeaderTag
            testId="tpHeaderPaExpirationTag"
            label="PA expiration"
            value={paExpiry.label}
            dotColor={paExpiry.dotColor}
          />
        ) : null}
      </Box>
      <Box sx={PAGE_HEADER_ACTIONS_SX}>{children}</Box>
    </Box>
  );
}
